// Marking done a task whose list still has open rows asks once — the bar and what is
// left open, then the act or not. A task with nothing open completes without asking.
// Completing keeps the list, read-only, as the record of how it ended.
import he from '../../i18n/he';
import Modal from '../Modal';
import { ListBar, ListCounts } from './ListGlance';

export default function CompleteTaskModal({ title, summary, onConfirm, onClose }) {
  return (
    <Modal title={he.lists.completeTitle} onClose={onClose} onSave={onConfirm} saveLabel={he.lists.completeConfirm}>
      <div className="modal-subject">
        <strong>{title}</strong>
      </div>
      <div className="list-complete">
        <ListBar summary={summary} thin />
        <div className="list-complete-row">
          <strong>{he.lists.leftOpen(summary.open)}</strong>
          <ListCounts summary={summary} />
        </div>
      </div>
    </Modal>
  );
}

// The one rule for the "בוצע" button wherever a task with a list shows it.
export const needsConfirm = (summary) => !!summary && summary.open > 0;
